import { t } from 'i18next';

export const orderTabs = {
  overview: {
    key: 'summary',
    label: t('orders.orderOverview'),
  },
  vehicle: {
    key: 'vehicle',
    label: t('common.vehicle.vehicle'),
  },
  jobs: {
    key: 'jobs',
    label: t('jobs.jobBuilder'),
  },
  schedule: {
    key: 'schedule',
    label: t('scheduling.schedule'),
  },
  notes: {
    key: 'notes',
    label: t('notes.notes'),
  },
  payments: {
    key: 'payments',
    label: t('payments.payments'),
  },
  surveys: {
    key: 'surveys',
    label: t('surveys.surveys'),
  },
  audit: {
    key: 'audit',
    label: t('common.audit.audit'),
  },
  inventory: {
    key: 'add-internal-product',
    label: t('products.addInternalProduct'),
  },
};
